export const selectLessons = (state) => {
    let res = [];
    state?.directionCourses?.forEach(el => {
      el?.material?.forEach(elem => {
        elem?.topicLesson?.forEach(element => {
          res.push({label: `Тема “${el.short_name}”, урок “${element?.name}”`, value:element?.id})
        })
      });
    });
    return res;
}